export default {
    html: {name: "HTML", imgSrc: 'html.png', weblink:'https://code.visualstudio.com/' },
    javascript: {name: "JavaScript", imgSrc: 'js.png', weblink:'https://code.visualstudio.com/' },
    css: {name: "CSS", imgSrc: 'css.png', weblink:'https://code.visualstudio.com/' },
    gimp: {name: "GIMP", imgSrc: 'gimp.png', weblink:'https://code.visualstudio.com/' },
    scratch: {name: "Scratch", imgSrc: 'scratch.png', weblink:'https://code.visualstudio.com/' },
    pinia: {name: "Pinia", imgSrc: 'pinia.png', weblink:'https://code.visualstudio.com/' },
    vue3: {name: "Vue 3", imgSrc: 'vue.png', weblink:'https://code.visualstudio.com/' },
}